export const ToastTimerConfig = {
    NORMAL_TOAST_DURATION: 5000, // ✅ 5 Seconds (Normal Toast)
    BLINKING_TOAST_DURATION: 30000, // ✅ 30 Seconds (Blinking Toast)
    BLINK_INTERVAL: 500, // ✅ 500ms per blink
  };
  